import get from 'lodash.get';

const getAvailableSubscriptionTypes = (rootState) =>
  get(rootState, 'partner.properties.availableSubscriptionTypes', []);

export default getAvailableSubscriptionTypes;
